import './userDashboard.css'
import React, {useContext, useEffect, useState} from 'react';
import AppHeader from "../app-header/app-header";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import api from "../../api";
import {UserContext} from "../../UserContext";
import {LanguageContext} from "../../languageContext";
import translations from '../../translations';
import TrainingSessionChart from "./trainingSessionChart";
import { useToast } from "../../ToastContext";
import LanguageDropDown from "../languageDropDown/dropDown";

const UserDashboard = () => {
    const [sessions, setSessions] = useState([]);
    const SERVER_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/api/v1/"
        : "/api/v1/";

    const [dashboardData, setDashboardData] = useState(null);
    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
    const { language } = useContext(LanguageContext);
    const { addToast } = useToast();
    const navigate = useNavigate();
    const navigateTo = (route) =>{
        navigate(`/${route.toLowerCase()}`);
    }

    const translate = (text) => {
        if (text) {
            return langOpt === 'Japanese' ? translations[text] : text;
        } else {
            return text
        }
    };

    const getSessions = async () => {
        try {
            // setLoading(true)
            if(!user.userEmail) return addToast(translate("Something went wrong"),"error")
            const response = await api.get(`training/sessions?userEmail=${user.userEmail}&stage=COMPLETED&record=10`);
            if (response.status === 200 && response.data) {
                setSessions(response.data.data);
                // setLoading(false)
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Error fetching question:", error);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const { user } = useContext(UserContext);
    useEffect(()=> {
        if(user){
            getDashboardData();
        }
    },[user])

    useEffect(()=> {
        setLangOpt(language);
    },[language])

    const getDashboardData = async () => {
        try{
            debugger
            const response = await api.get(`training/sessionsDashboard?userEmail=${user.userEmail}`);
            setDashboardData(response.data.data);
            getSessions();
            
        }catch (e){
            console.log(e);
        }finally{

        }
    }

    return (
        <>
            <div className="custom-container">
                <div className="training-buttons">
                    <button className="white-red-btn" onClick={()=>{navigateTo("training-results")}}>{translate("View Past Results")}</button>
                    <button className="red-white-btn" onClick={()=>{navigateTo("training")}} >{translate("Start Training")}</button>
                </div>
                <div className="overview-cards">
                    <span className="overview-cards-heading">{translate("Training Overview")}</span>
                    <div className="overview-cards-list">
                        <div className="overview-card">
                            <p>{translate("Completed Training Session")}</p>
                            <p><strong>{dashboardData?.totalCompletedTrainingSessions ? dashboardData.totalCompletedTrainingSessions :"-"}</strong></p>
                        </div>
                        <div className="overview-card">
                            <p>{translate("Average Score")}</p>
                            <p><strong>{dashboardData?.averageScore ? dashboardData.averageScore + "%" : "-"}</strong></p>
                        </div>
                        <div className="overview-card">
                            <p>{translate("Best Achieved Score")}</p>
                            <p><strong>{dashboardData?.bestAchievedScore ? dashboardData.bestAchievedScore:"-"}</strong></p>
                        </div>
                        <div className="overview-card">
                            <p>{translate("Last Training Taken On")}</p>
                            <p><strong>{dashboardData?.lastTrainingTakenOn ? formatDate(dashboardData.lastTrainingTakenOn) : "-" }</strong></p>
                        </div>
                    </div>
                </div>
                <div className="overview-cards">
                    <span className="overview-cards-heading">{translate("Past Results")}</span>
                    <TrainingSessionChart trainingSessionList={sessions} translate={translate} />
                    {/*<img src="./graph.png" alt="graph-image"/>*/}
                </div>
                </div>
        </>
    )
}

export default UserDashboard